import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ThemeColorManager = () => {
    const location = useLocation();

    useEffect(() => {
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (!metaThemeColor) return;

        // Set initial color
        if (location.pathname === '/') {
            metaThemeColor.setAttribute('content', '#fcf9f8');
        } else {
            metaThemeColor.setAttribute('content', '#ffffff');
        }

        const updateThemeColor = () => {
            const backdrop = document.querySelector('[style*="background: rgba(0, 0, 0, 0.3)"]');
            
            if (backdrop) {
                const computedStyle = window.getComputedStyle(backdrop);
                const opacity = parseFloat(computedStyle.opacity);
                
                // Interpolate between white and gray based on opacity
                const r = Math.round(255 - (255 - 179) * opacity); // 179 is the gray value for #B3B3B3
                const g = Math.round(255 - (255 - 179) * opacity);
                const b = Math.round(255 - (255 - 179) * opacity);
                
                const newColor = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
                metaThemeColor.setAttribute('content', newColor);
            } else {
                // Set default color based on path
                if (location.pathname === '/') {
                    metaThemeColor.setAttribute('content', '#fcf9f8');
                } else {
                    metaThemeColor.setAttribute('content', '#ffffff');
                }
            }
        };

        // Set up observer to watch for backdrop changes
        const observer = new MutationObserver(() => {
            requestAnimationFrame(updateThemeColor);
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });

        return () => {
            observer.disconnect();
            // Reset to default color on cleanup
            if (location.pathname === '/') {
                metaThemeColor.setAttribute('content', '#fcf9f8');
            } else {
                metaThemeColor.setAttribute('content', '#ffffff');
            }
        };
    }, [location.pathname]);

    return null;
};

export default ThemeColorManager; 